import { Box, Stack } from "@mui/material";
import i18n from "src/i18n";

/**
 * Download AWB Tour Steps:
 * 0: body (Welcome)
 * 1: #mapitShip-btn - MapitShip sidebar button
 * 2: #shipment-btn - Shipment button in sidebar
 * 3: #step-ORDER_ASSIGNED_TO_SHIPPING_COMPANY - Status tab for assigned orders
 * 4: .MuiDataGrid-row - First row in the data grid (dynamic - may skip to fallback)
 * 5: #mapitShip-download-awb-btn - Download AWB button in dialog
 * 6: body (Completion)
 * 
 * Fallback step (4-fallback): Shows image explaining AWB download when no rows exist
 */

// Step indices constants for easy reference
export const DOWNLOAD_AWB_STEP_INDICES = {
    WELCOME: 0,
    MAPIT_SHIP_BTN: 1,
    SHIPMENT_BTN: 2,
    STATUS_TAB: 3,
    DATA_GRID_ROW: 4,
    DOWNLOAD_AWB_BTN: 5,
    NO_DATA_FALLBACK: 6,
    COMPLETION: 7,
};

export const downloadAwbTourSteps = (isMobile, isScrollableDrawer) => [
    // Step 0: Welcome
    {
        target: "body",
        title: (
            <Stack justifyContent="center" alignItems="center">
                <img width={50} style={{ objectFit: "cover" }} src="/static/hand-up.webp" alt="" />
                {i18n.t("tutorial.downloadAwbTour.title")}
            </Stack>
        ),
        content: i18n.t("tutorial.downloadAwbTour.welcome"),
        placement: "center",
        disableBeacon: true,
    },
    // Step 1: MapitShip sidebar button
    {
        target: "#mapitShip-btn",
        content: i18n.t("tutorial.downloadAwbTour.mapitShipBtn"),
        placement: "left",
        styles: {
            spotlight: {
                marginTop: isScrollableDrawer ? isMobile ? 160 : 167 : 0,
            },
        },
    },
    // Step 2: Shipment button in sidebar
    {
        target: "#shipment-btn",
        content: i18n.t("tutorial.downloadAwbTour.shipmentBtn"),
        placement: "top",
        styles: {
            spotlight: {
                marginTop: isScrollableDrawer ? isMobile ? 445 : 450 : 0,
            },
        },
    },
    // Step 3: Status tab for assigned to shipping company
    {
        target: "#simple-tab-1",
        content: i18n.t("tutorial.downloadAwbTour.statusTab"),
        placement: "bottom",
    },
    // Step 4: Data grid row (dynamic - content may change based on data availability)
    {
        target: "#mapit-ship-orders-table",
        content: i18n.t("tutorial.downloadAwbTour.selectRow"),
        placement: "top",
        // This step's target will be dynamically validated
        data: {
            isDynamic: true,
            fallbackTarget: "body",
        },
    },
    // Step 5: Download AWB button
    // {
    //     target: "#mapitShip-download-awb-btn",
    //     content: i18n.t("tutorial.downloadAwbTour.downloadAwbBtn"),
    //     placement: "top",
    //     disableBeacon: true,
    //     styles: {
    //         spotlight: {
    //             marginTop: isScrollableDrawer ? isMobile ? 0 : 32 : 0,
    //         },
    //     },
    // },
    // Step 6: No data fallback - Shows when no shipments exist
    {
        target: "body",
        title: (
            <Stack justifyContent="center" alignItems="center">
                <img
                    width={isMobile ? 370 : 600}
                    style={{ objectFit: "contain", marginBottom: 16 }}
                    src="/static/download-awb-guide.gif"
                    alt="Download AWB Guide"
                />
            </Stack>
        ),
        content: i18n.t("tutorial.downloadAwbTour.noDataFallback"),
        placement: "center",
        styles: {
            tooltip: {
                maxWidth: isMobile ? 370 : 700,
                width: isMobile ? 370 : 700,
            },
        },
    },
    // Step 7: Completion
    {
        target: "body",
        title: (
            <Box display="flex" justifyContent="center" alignItems="center">
                <img width={50} style={{ objectFit: "cover" }} src="/static/rocket.png" alt="" />
            </Box>
        ),
        content: i18n.t("tutorial.downloadAwbTour.completion"),
        placement: "center",
    },
];
